<template>
  <div class="page">
    <div class="bg-content padding15 m-b-24">
      <listOperate :caseSearchReq="caseSearchReq" :caseStatusList="caseStatusList" :labelList="labelList" :caseRes="caseRes"></listOperate>
      <el-form size="small" label-width="100px">
        <!-- 第一行 -->
        <el-row :gutter="12">
          <el-col :span="6">
            <el-form-item label="案件状态">
              <!-- <el-select v-model="caseSearchReq.caseStatus" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in caseStatusList" :key="item.modelCode" :label="item.modelName" :value="item.modelCode" :title="item.modelName"/>
              </el-select> -->
              <caseStatus-selector v-model="caseSearchReq.caseStatus" :caseStatus="caseStatusDefault"></caseStatus-selector>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="案件批次号">
              <batch-selector v-model="caseSearchReq.batchNo" :batchNo="batchNoDefault" :batchId="batchId" :testing="false"></batch-selector>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="本人状态">
              <!-- <el-select v-model="caseSearchReq.selfStatus" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in selfStatusList" :key="item.modelCode" :label="item.modelName" :value="item.modelCode" :title="item.modelName"/>
              </el-select> -->
              <selfStatus-selector v-model="caseSearchReq.selfStatus" :selfStatus="selfStatusDefault"></selfStatus-selector>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系人状态">
              <!-- <el-select v-model="caseSearchReq.contactStatus" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in contactStatusList" :key="item.modelCode" :label="item.modelName" :value="item.modelCode" :title="item.modelName"/>
              </el-select> -->
              <contactStatus-selector v-model="caseSearchReq.contactStatus" :selfStatus="contactStatusDefault"></contactStatus-selector>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 第二行 -->
        <el-row v-if="ruleSearchShow" :gutter="12">
          <el-col :span="6">
            <el-form-item label="导入时间">
              <el-date-picker v-model="caseSearchReq.importStartTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="至">
              <el-date-picker v-model="caseSearchReq.importEndTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="贷款机构">
              <el-select v-model="caseSearchReq.loanInstitution" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in loanInstitutionList" :key="item" :label="item" :value="item" :title="item"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="策略组">
              <el-select v-model="caseSearchReq.strategyGroup" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in strategyGroupList" :key="item.id" :label="item.groupName" :value="item.id" :title="item.groupName"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 第三行 -->
        <el-row v-if="ruleSearchShow" :gutter="12">
          <el-col :span="6">
            <el-form-item label="最后联系时间">
              <el-date-picker v-model="caseSearchReq.lastAnswerStartTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="至">
              <el-date-picker v-model="caseSearchReq.lastAnswerEndTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="轮次">
              <el-select v-model="caseSearchReq.replyTimes" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in replyTimesList" :key="item.value" :label="item.label" :value="item.value" :title="item.label"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="标签">
              <el-select v-model="caseSearchReq.labelName" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in labelList" :key="item.name" :label="item.name" :value="item.name" :title="item.name"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 第四行 -->
         <el-row v-if="ruleSearchShow && this.$hasPerm('B002&3')" :gutter="12">
         <el-col :span="6">
            <el-form-item label="语音成功次数">
              <el-input v-model="caseSearchReq.callSuccessCountMin" style="width: 100%;" placeholder="请输入语音成功次数起" @keyup.native="numberCallSuccessCountMin"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="至">
                <el-input v-model="caseSearchReq.callSuccessCountMax" style="width: 100%;" placeholder="请输入语音成功次数止" @keyup.native="numberCallSuccessCountMax"></el-input>
            </el-form-item>
          </el-col>
           <el-col :span="6">
              <el-form-item label="短信成功次数">
                <el-input v-model="caseSearchReq.msgSuccessCountMin" style="width: 100%;" placeholder="请输入短信成功次数起" @keyup.native="numberMsgSuccessCountMin"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="至">
                  <el-input v-model="caseSearchReq.msgSuccessCountMax" style="width: 100%;" placeholder="请输入短信成功次数止" @keyup.native="numberMsgSuccessCountMax"></el-input>
              </el-form-item>
            </el-col>
        </el-row>
        <!-- 第五行 -->
        <el-row v-if="ruleSearchShow && this.$hasPerm('B002&3')" :gutter="12">
           <el-col :span="6">
              <el-form-item label="外呼中次数">
                <el-input v-model="caseSearchReq.callProcessCountMin" style="width:100%" placeholder="请输入外呼中次数起" @keyup.native="numberCallProcessCountMin"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="至">
                <el-input v-model="caseSearchReq.callProcessCountMax" style="width: 100%;" placeholder="请输入外呼中次数止" @keyup.native="numberCallProcessCountMax"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="最新通话时长">
                <el-input v-model="caseSearchReq.latestAnswerDurationMin" style="width: 100%;" placeholder="请输入最新通话时长起" @keyup.native="numberLatestAnswerDurationMin"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="至">
                  <el-input v-model="caseSearchReq.latestAnswerDurationMax"  style="width: 100%;" placeholder="请输入最新通话时长止" @keyup.native="numberLatestAnswerDurationMax"></el-input>
              </el-form-item>
            </el-col>
        </el-row>
        <!-- 第六行 -->
         <el-row v-if="ruleSearchShow" :gutter="12">
          <el-col :span="6">
            <el-form-item label="作业停止日">
              <el-date-picker v-model="caseSearchReq.collectionStartDay" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="至">
              <el-date-picker v-model="caseSearchReq.collectionEndDay" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="作业状态">
              <el-select v-model="caseSearchReq.urgeStatus" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in caseUrgeStatusList" :key="item.value" :label="item.label" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-dropdown @command="labelChange" style="position:relative;top:5px;left:7%">
                <span class="el-dropdown-link">
                  {{caseSearchReq.label}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="aCaseId,进件号">进件号</el-dropdown-item>
                  <el-dropdown-item command="mobile,手机号">手机号</el-dropdown-item>
                  <el-dropdown-item command="name,姓名">姓名</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-form-item>
                <el-input v-model="caseSearchReq.keyStr" placeholder="请选择" style="position:relative;top: -20px;"></el-input>
              </el-form-item>
          </el-col>
        </el-row>
        <!-- 第七行 -->
        <el-row v-if="ruleSearchShow" :gutter="12">
          <el-col :span="12" style="margin-top: -1%;">
            <el-form-item label="AI评分">
              <el-col :span="4">
                <el-switch v-model="caseSearchReq.aiSelected"/>
              </el-col>
              <el-col :span="16">
                <transition name="component-fade" mode="out-in">
                  <el-slider v-if="caseSearchReq.aiSelected" v-model="caseSearchReq.difficultyScore" range :min="0" :max="100"/>
                </transition>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="逾期天数" class="overdue-dates-form-item">
              <el-switch v-model="caseSearchReq.overdueDatesSelected"/>
              <template v-if="caseSearchReq.overdueDatesSelected">
                <el-input v-model="caseSearchReq.overdueDatesMin" placeholder="起" class="overdue-input" @keyup.native="numberOverdueDatesMin"></el-input>
                <span class="overdue-separator">至</span>
                <el-input v-model="caseSearchReq.overdueDatesMax" placeholder="止" class="overdue-input" @keyup.native="numberOverdueDatesMax"></el-input>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row v-if="ruleSearchShow" :gutter="12">
          <el-col :span="24">
            <div class="padding15-tb text right">
              <el-button @click="caseSearchReq.page = 1;caseSearch()" type="primary" size="mini" plain> <i class="fa fa-search"></i> 搜索</el-button>
              <el-button @click="reset" size="mini">重置</el-button>
              <el-button v-if="ruleSearchShow" size="mini" type="text" @click="ruleSearchShow = false">收缩<el-icon class="el-icon-arrow-up"></el-icon></el-button>
              <el-button v-else size="mini" type="text" @click="ruleSearchShow = true">展开<el-icon class="el-icon-arrow-down"></el-icon></el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="padding15-tb text right" v-if="!ruleSearchShow">
        <el-button @click="caseSearchReq.page = 1;caseSearch()" type="primary" size="mini" plain> <i class="fa fa-search"></i> 搜索</el-button>
        <el-button @click="reset" size="mini">重置</el-button>
        <el-button v-if="ruleSearchShow" size="mini" type="text" @click="ruleSearchShow = false">收缩<el-icon class="el-icon-arrow-up"></el-icon></el-button>
        <el-button v-else size="mini" type="text" @click="ruleSearchShow = true">展开<el-icon class="el-icon-arrow-down"></el-icon></el-button>
      </div>
    </div>
    <div class="padding15 bg-content">
       <el-table :data="caseRes.list" :key="tableKey" max-height="500" v-loading="loading" size="small" :row-style="{cursor: 'pointer'}" highlight-current-row @sort-change="sort" @row-click="detail">
         <el-table-column label="进件号" min-width="100px" fixed property="aCaseId" align="center">
          <template slot-scope="scope">
            <span :title="scope.row.aCaseId" v-if="scope.row.aCaseId === '' || scope.row.aCaseId == null">--</span>
            <span :title="scope.row.aCaseId" v-else-if="scope.row.aCaseId.length <= 10">{{scope.row.aCaseId}}</span>
            <span :title="scope.row.aCaseId" v-else>{{scope.row.aCaseId.substring(0,10) + '...'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="批次号" min-width="100px" fixed align="center" v-if="this.$collectible()">
          <template slot-scope="scope">
            <span :title="scope.row.batchNo" v-if="scope.row.batchNo === '' || scope.row.batchNo == null">--</span>
            <span :title="scope.row.batchNo" v-else-if="scope.row.batchNo.length <= 10">{{scope.row.batchNo}}</span>
            <span :title="scope.row.batchNo" v-else>{{scope.row.batchNo.substring(0,10) + '...'}}</span>
          </template>
        </el-table-column>
        <el-table-column property="loanInstitutions" label="贷款机构" min-width="70px" v-if="this.$collectible()">
          <template slot-scope="scope">
            <span :title="scope.row.loanInstitutions" v-if="scope.row.loanInstitutions === '' || scope.row.loanInstitutions == null">--</span>
            <span :title="scope.row.loanInstitutions" v-else-if="scope.row.loanInstitutions.length > 4">{{scope.row.loanInstitutions.substring(0,4) + '...'}}</span>
            <span :title="scope.row.loanInstitutions" v-else>{{scope.row.loanInstitutions}}</span>
          </template>
        </el-table-column>
        <el-table-column property="loanName" label="姓名" min-width="60px" v-if="this.$collectible()">
          <template slot-scope="scope">
            <span v-if="scope.row.loanName === '' || scope.row.loanName == null">--</span>
            <span v-else-if="scope.row.loanName.length > 6">{{scope.row.loanName.substring(0,6) + '...'}}</span>
            <span v-else>{{scope.row.loanName}}</span>
          </template>
        </el-table-column>
        <el-table-column property="mobile" label="手机号" min-width="70px" align="center" v-if="!this.$collectible()"/>
        <el-table-column property="numberHomeLocation" label="号码归属地" min-width="70px" align="center" v-if="!this.$collectible()"/>
        <el-table-column property="importTime" label="导入时间" min-width="100px" align="center" sortable="custom">
          <template slot-scope="scope">
            <span v-if="scope.row.importTime === '' || scope.row.importTime == null">--</span>
            <span v-else>{{scope.row.importTime}}</span>
          </template>
        </el-table-column>
        <el-table-column property="overdueDates" label="逾期天数" min-width="100px" align="center" sortable="custom" v-if="this.$collectible()"/>
        <el-table-column property="delegateAmount" label="委托金额" min-width="100px" align="center" sortable="custom" v-if="this.$collectible()"/>
        <el-table-column property="caseStatusStr" label="案件状态" min-width="70px" align="center"/>
        <!-- <el-table-column property="contactNum" label="联系人数" min-width="70px" align="center" v-if="this.$collectible()"/> -->
        <el-table-column label="轮次" min-width="50px" align="center" v-if="this.$collectible()">
          <template slot-scope="scope">
            <span v-if="scope.row.replyTimes">{{scope.row.replyTimes + '次'}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column property="difficultyScore" label="AI评分" min-width="90px" align="center" sortable="custom" v-if="this.$collectible()">
          <template slot-scope="scope">
            <span v-if="scope.row.difficultyScore">{{scope.row.difficultyScore}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="策略组" min-width="60px" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.groupName">{{scope.row.groupName}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="作业状态" min-width="70px" v-if="this.$collectible()">
          <template slot-scope="scope">
            <span v-if="scope.row.urgeStatus == '0'">未作业</span>
            <span v-if="scope.row.urgeStatus == '1'">作业中</span>
            <span v-if="scope.row.urgeStatus == '-1'">暂停作业</span>
            <span v-if="scope.row.urgeStatus == '2'">作业完成</span>
            <span v-if="scope.row.urgeStatus == '' || scope.row.urgeStatus == null">--</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="最高减免" min-width="70px" align="center" v-if="this.$collectible()">
          <template slot-scope="scope">
            <span v-if="scope.row.planDiscount">{{scope.row.planDiscount + '%'}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column property="deduction" label="给予减免" min-width="70px" align="center" v-if="this.$collectible()">
          <template slot-scope="scope">
            <span v-if="scope.row.deduction">{{scope.row.deduction | money}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column> -->
        <el-table-column property="collectionEndDay" label="作业停止日" align="center" sortable="custom" min-width="105px" v-if="this.$collectible()">
          <template slot-scope="scope">
            <span v-if="scope.row.collectionEndDay === '' || scope.row.collectionEndDay == null">--</span>
            <span v-else-if="scope.row.collectionEndDay.length >= 10">{{scope.row.collectionEndDay.substring(5,10)}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="对象" min-width="50px" v-if="this.$collectible()">
          <template slot-scope="scope">
            <span :title="scope.row.collectSendObjectName" v-if="scope.row.collectSendObjectName === '' || scope.row.collectSendObjectName == null">--</span>
            <span :title="scope.row.collectSendObjectName" v-else-if="scope.row.collectSendObjectName.length > 6">{{scope.row.collectSendObjectName.substring(0,6) + '...'}}</span>
            <span :title="scope.row.collectSendObjectName" v-else-if="scope.row.collectSendObjectName.length <= 6">{{scope.row.collectSendObjectName}}</span>
          </template>
        </el-table-column> -->
        <el-table-column property="callOutCount" label="外呼次数" min-width="60px" align="center" v-if="!this.$collectible()"/>

        <el-table-column property="callSuccessCount" v-if="this.$hasPerm('B002&3')" label="语音成功次数" min-width="100px" align="center"/>
        <el-table-column property="msgSuccessCount" v-if="this.$hasPerm('B002&3')" label="短信成功次数" min-width="100px" align="center" />
        <el-table-column property="callProcessCount" v-if="this.$hasPerm('B002&3')" label="外呼中次数" min-width="100px" align="center" />
        <el-table-column property="latestAnswerDuration" v-if="this.$hasPerm('B002&3')" label="最新通话时长" min-width="100px" align="center" />

        <el-table-column property="lastAnswerTime" label="最新联系时间" min-width="120px" align="center" sortable="custom">
          <template slot-scope="scope">
            <span v-if="scope.row.lastAnswerTime === '' || scope.row.lastAnswerTime == null">--</span>
            <span v-else-if="scope.row.lastAnswerTime.length >= 19">{{scope.row.lastAnswerTime.substring(5,16)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="本人联系状态" min-width="100px" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.selfContactStatusStr" :class="`tag ${scope.row.selfContactStatusColor}`">{{scope.row.selfContactStatusStr}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <!-- <el-table-column property="noSelfStatus" label="联系人状态" min-width="100px" align="center" v-if="this.$collectible()">
          <template slot-scope="scope">
            <span v-if="scope.row.noSelfContactStatusStr" :class="`tag ${scope.row.noSelfContactStatusColor}`">{{scope.row.noSelfContactStatusStr}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column> -->
       </el-table>
       <div class="text center margin15-tb">
         <el-pagination background layout="prev, pager, next, sizes, total"
           :total="caseRes.totalRecords" :page-sizes="[50, 100, 200]"
           :page-size="caseSearchReq.limit" :current-page="caseSearchReq.page"
           @current-change="currentChange" @size-change="sizeChange"/>
       </div>
    </div>
  </div>
</template>
<script>
import BatchSelector from '../../../components/bussiness-select/BatchSelector';
import CaseStatusSelector from '../../../components/bussiness-select/CaseStatusSelector';
import SelfStatusSelector from '../../../components/bussiness-select/SelfStatusSelector';
import ContactStatusSelector from '../../../components/bussiness-select/ContactStatusSelector';
import listOperate from './listOperate';

const Base64 = require('js-base64').Base64;

export default {
  inject: ['reload'],
  data() {
    return {
      tableKey: 0,
      // 搜索条件结果
      caseStatusList: [],
      selfStatusList: [],
      contactStatusList: [],
      loanInstitutionList: [],
      strategyGroupList: [],
      replyTimesList: [
        {
          value: 'REPLY_TIMES_ONE',
          label: '0'
        },
        {
          value: 'REPLY_TIMES_TWO',
          label: '1'
        },
        {
          value: 'REPLY_TIMES_THREE',
          label: '2-5'
        },
        {
          value: 'REPLY_TIMES_FOUR',
          label: '6-10'
        },
        {
          value: 'REPLY_TIMES_FIVE',
          label: '>10'
        }
      ],
      labelList: [],
      caseUrgeStatusList: [
        { value: '0', label: '未作业' },
        { value: '1', label: '作业中' },
        { value: '-1', label: '暂停作业' },
        { value: '2', label: '作业完成' }
      ],
      //
      ruleSearchShow: false,
      loading: false,
      caseSearchReq: {
        page: 1,
        limit: 50,
        order: 'importTime',
        sort: 'desc',
        // 搜索条件
        keyType: 'aCaseId',
        keys: [],
        caseStatus: [],
        batchNo: [],
        selfStatus: [],
        contactStatus: [],
        importStartTime: null,
        importEndTime: null,
        loanInstitution: [],
        strategyGroup: [],
        lastAnswerStartTime: null,
        lastAnswerEndTime: null,
        replyTimes: [],
        labelName: [],
        collectionStartDay: null,
        collectionEndDay: null,
        aiSelected: false,
        overdueDatesSelected: false,
        difficultyScore: [null, null],
        overdueDates: [null, null],
        overdueDatesMin: null,
        overdueDatesMax: null,
        urgeStatus: [],
        label: '进件号',
        keyStr: null,
        callSuccessCountMin: null,
        callSuccessCountMax: null,
        msgSuccessCountMin: null,
        msgSuccessCountMax: null,
        callProcessCountMin: null,
        callProcessCountMax: null,
        latestAnswerDurationMin: null,
        latestAnswerDurationMax: null
      },
      caseRes: { totalRecords: 0, list: [] },
      batchNoDefault: [],
      caseStatusDefault: [],
      selfStatusDefault: [],
      contactStatusDefault: [],
      batchId: null
    };
  },
  mounted() {
    this.loanInstitutionSearch();
    this.strategyGroupSearch();
    this.labelSearch();
    this.readCache();
  },
  methods: {
    // 获取批次数据
    getBatchData() {
      const caseSearchCache = localStorage.getItem('caseSearchCache');
      if (caseSearchCache) {
        const temp = JSON.parse(caseSearchCache);
        if (temp && temp.batchNo && temp.batchNo.length > 0) {
          this.batchId = Number(temp.batchNo[0]);
          // this.$ajax({
          //   url: '/robotCase/getBatchDataList',
          //   params: {
          //     'val': '',
          //     'testing': '',
          //     'batchId': Number(temp.batchNo[0])
          //   }
          // }).then((res) => {
          //   if (res.data && res.data.list && res.data.list.length > 0) {
          //     this.caseRes = res.data;
          //     this.tableKey++;
          //     const batchNo = res.data.list[0].batchNo;
          //     this.batchNoDefault = batchNo ? [batchNo] : [];
          //     temp.batchNo = [];
          //     localStorage.setItem('caseSearchCache', JSON.stringify(temp));
          //   }
          // });
        }
      }
    },
    labelChange(command) {
      this.caseSearchReq.keyType = command.split(',')[0];
      this.caseSearchReq.label = command.split(',')[1];
    },
    loanInstitutionSearch() {
      this.$ajax({
        method: 'GET',
        url: '/robotCase/getLoanInstitutionsList'
      }).then((res) => {
        this.loanInstitutionList = res.data;
      });
    },
    strategyGroupSearch() {
      this.$ajax({
        method: 'GET',
        url: '/robotCase/getStrategyList'
      }).then((res) => {
        this.strategyGroupList = res.data;
      });
    },
    labelSearch() {
      this.$ajax({
        method: 'GET',
        url: '/label/getLable'
      }).then((res) => {
        this.labelList = res.data;
      });
    },
    validateParameters() {
      if (
        (this.caseSearchReq.callSuccessCountMin !== null && this.caseSearchReq.callSuccessCountMin !== '') ||
        (this.caseSearchReq.callSuccessCountMax !== null && this.caseSearchReq.callSuccessCountMax !== '') ||
        (this.caseSearchReq.msgSuccessCountMin !== null && this.caseSearchReq.msgSuccessCountMin !== '') ||
        (this.caseSearchReq.msgSuccessCountMax !== null && this.caseSearchReq.msgSuccessCountMax !== '') ||
        (this.caseSearchReq.callProcessCountMin !== null && this.caseSearchReq.callProcessCountMin !== '') ||
        (this.caseSearchReq.callProcessCountMax !== null && this.caseSearchReq.callProcessCountMax !== '') ||
        (this.caseSearchReq.latestAnswerDurationMin !== null && this.caseSearchReq.latestAnswerDurationMin !== '') ||
        (this.caseSearchReq.latestAnswerDurationMax !== null && this.caseSearchReq.latestAnswerDurationMax !== '')
      ) {
        return false; // 如果有任何一个参数不为空和null，返回 false
      }
      return true; // 所有参数都为空，返回 true
    },
    attachCheck() {
      if (
        (this.caseSearchReq.batchNo !== null && this.caseSearchReq.batchNo.length > 0) ||
        (this.caseSearchReq.importStartTime !== null && this.caseSearchReq.importStartTime !== '')
      ) {
        return true; // 如果有任何一个参数不为空和null，返回 true
      }
      return false; // 所有参数都为空，返回 false
    },
    caseSearch() {
      if ((!this.validateParameters()) && (!this.attachCheck())) {
        // 参数验证不通过，执行相应的操作
        this.$message.error('语音成功|短信成功|最新通话时长|外呼中次数的查询需要选择批次号|导入开始时间！');
        return;
      }
      this.loading = true;
      if (this.caseSearchReq.keyStr === null || this.caseSearchReq.keyStr === '') {
        this.caseSearchReq.keyType = null;
        this.caseSearchReq.keys = [];
      } else {
        this.caseSearchReq.keys = this.caseSearchReq.keyStr.split(',');
      }
      // 逾期天数：开关打开时处理必填及默认值
      if (this.caseSearchReq.overdueDatesSelected) {
        const minVal = this.caseSearchReq.overdueDatesMin !== null && this.caseSearchReq.overdueDatesMin !== '' ? Number(this.caseSearchReq.overdueDatesMin) : null;
        const maxVal = this.caseSearchReq.overdueDatesMax !== null && this.caseSearchReq.overdueDatesMax !== '' ? Number(this.caseSearchReq.overdueDatesMax) : null;
        if (minVal === null && maxVal === null) {
          this.$message.error('逾期天数开关打开时，请至少填写一个逾期天数！');
          this.loading = false;
          return;
        }
        // 校验范围 -50~365
        if ((minVal !== null && (minVal < -50 || minVal > 365)) || (maxVal !== null && (maxVal < -50 || maxVal > 365))) {
          this.$message.error('逾期天数范围为-50~365！');
          this.loading = false;
          return;
        }
        // 未填则取默认值：起=-50，止=365
        this.caseSearchReq.overdueDates = [minVal !== null ? minVal : -50, maxVal !== null ? maxVal : 365];
      } else {
        this.caseSearchReq.overdueDates = [null, null];
      }
      const left = this;
      if (this.caseSearchReq.keyStr) {
        if (!this.caseSearchReq.keyType) {
          this.caseSearchReq.keyType = 'aCaseId';
        }
      }
      this.$ajax({
        method: 'POST',
        url: '/caseList/list',
        data: this.caseSearchReq
      }).then((res) => {
        this.tableKey++;
        left.caseRes = res.data;
        // 写缓存
        left.writeCache();
        left.loading = false;
      });
    },
    // 录音转文本
    wavToText() {
      this.$ajax({
        method: 'POST',
        url: '/caseList/caseWavToText',
        data: this.caseSearchReq
      }).then(() => {
        this.$message.success('操作成功');
      });
    },
    currentChange(page) {
      this.caseSearchReq.page = page;
      this.caseSearch();
    },
    // 显示条数
    sizeChange(num) {
      this.caseSearchReq.limit = num;
      this.caseSearch();
    },
    sort(column) {
      const prop = column.prop === null ? 'importTime' : column.prop;
      const order = column.order === null ? 'descending' : column.order;
      this.caseSearchReq.order = prop;
      if (order === 'descending') {
        this.caseSearchReq.sort = 'desc';
      }
      if (order === 'ascending') {
        this.caseSearchReq.sort = 'asc';
      }
      this.caseSearch();
    },
    writeCache() {
      localStorage.setItem('caseSearchCompanyId', this.$account().companyId);
      const caseSearchCache = JSON.stringify(this.caseSearchReq);
      localStorage.setItem('caseSearchCache', caseSearchCache);
    },
    readCache() {
      const companyId = localStorage.getItem('caseSearchCompanyId');
      const caseSearchCache = localStorage.getItem('caseSearchCache');
      if (this.$account().companyId === Number(companyId) && caseSearchCache) {
        this.reqCopy(caseSearchCache);
        // 如果有批次号，则调用 getBatchData
        if (this.caseSearchReq.batchNo && this.caseSearchReq.batchNo.length > 0) {
          this.getBatchData();
        }
      } else {
        localStorage.removeItem('caseSearchCompanyId');
        localStorage.removeItem('caseSearchCache');
        this.reset();
      }
      this.caseSearch();
    },
    reset() {
      this.caseSearchReq.page = 1;
      this.caseSearchReq.limit = 50;
      this.caseSearchReq.order = 'importTime';
      this.caseSearchReq.sort = 'desc';
      this.caseSearchReq.keyType = 'aCaseId';
      this.caseSearchReq.keys = [];
      this.caseSearchReq.caseStatus = [];
      this.caseSearchReq.batchNo = [];
      this.caseSearchReq.selfStatus = [];
      this.caseSearchReq.contactStatus = [];
      this.caseSearchReq.importStartTime = null;
      this.caseSearchReq.importEndTime = null;
      this.caseSearchReq.loanInstitution = [];
      this.caseSearchReq.strategyGroup = [];
      this.caseSearchReq.lastAnswerStartTime = null;
      this.caseSearchReq.lastAnswerEndTime = null;
      this.caseSearchReq.replyTimes = [];
      this.caseSearchReq.labelName = [];
      this.caseSearchReq.collectionStartDay = null;
      this.caseSearchReq.collectionEndDay = null;
      this.caseSearchReq.difficultyScore = [null, null];
      this.caseSearchReq.overdueDates = [null, null];
      this.caseSearchReq.overdueDatesMin = null;
      this.caseSearchReq.overdueDatesMax = null;
      this.caseSearchReq.aiSelected = false;
      this.caseSearchReq.overdueDatesSelected = false;
      this.caseSearchReq.urgeStatus = [];
      this.caseSearchReq.keyStr = null;
      this.caseSearchReq.label = '进件号';
      this.caseSearchReq.callSuccessCountMin = null;
      this.caseSearchReq.callSuccessCountMax = null;
      this.caseSearchReq.msgSuccessCountMin = null;
      this.caseSearchReq.msgSuccessCountMax = null;
      this.caseSearchReq.callProcessCountMin = null;
      this.caseSearchReq.callProcessCountMax = null;
      this.caseSearchReq.latestAnswerDurationMin = null;
      this.caseSearchReq.latestAnswerDurationMax = null;
      this.writeCache();
      this.reload();
    },
    detail(row) {
      window.open(`/main/case/detail/${Base64.encode(row.id)}`);
    },
    reqCopy(jsonStr) {
      const temp = JSON.parse(jsonStr);
      if (temp) {
        this.caseSearchReq.page = temp.page ? temp.page : 1;
        this.caseSearchReq.limit = temp.limit ? temp.limit : 50;
        this.caseSearchReq.order = temp.order ? temp.order : 'importTime';
        this.caseSearchReq.sort = temp.sort ? temp.sort : 'desc';
        this.caseSearchReq.keyType = temp.keyType ? temp.keyType : 'aCaseId';
        this.caseSearchReq.keys = temp.keys ? temp.keys : [];
        this.caseSearchReq.caseStatus = temp.caseStatus ? temp.caseStatus : [];
        this.caseSearchReq.batchNo = temp.batchNo ? temp.batchNo : [];
        this.caseSearchReq.selfStatus = temp.selfStatus ? temp.selfStatus : [];
        this.caseSearchReq.contactStatus = temp.contactStatus ? temp.contactStatus : [];
        this.caseSearchReq.importStartTime = temp.importStartTime ? temp.importStartTime : null;
        this.caseSearchReq.importEndTime = temp.importEndTime ? temp.importEndTime : null;
        this.caseSearchReq.loanInstitution = temp.loanInstitution ? temp.loanInstitution : [];
        this.caseSearchReq.strategyGroup = temp.strategyGroup ? temp.strategyGroup : [];
        this.caseSearchReq.lastAnswerStartTime = temp.lastAnswerStartTime ? temp.lastAnswerStartTime : null;
        this.caseSearchReq.lastAnswerEndTime = temp.lastAnswerEndTime ? temp.lastAnswerEndTime : null;
        this.caseSearchReq.replyTimes = temp.replyTimes ? temp.replyTimes : [];
        this.caseSearchReq.labelName = temp.labelName ? temp.labelName : [];
        this.caseSearchReq.collectionStartDay = temp.collectionStartDay ? temp.collectionStartDay : null;
        this.caseSearchReq.collectionEndDay = temp.collectionEndDay ? temp.collectionEndDay : null;
        this.caseSearchReq.aiSelected = temp.aiSelected != null ? temp.aiSelected : false;
        this.caseSearchReq.overdueDatesSelected = temp.overdueDatesSelected != null ? temp.overdueDatesSelected : false;
        this.caseSearchReq.difficultyScore = temp.difficultyScore ? temp.difficultyScore : [null, null];
        // 兼容旧缓存 overdueDates 数组格式，转为新格式 overdueDatesMin/overdueDatesMax
        if (temp.overdueDatesMin !== undefined || temp.overdueDatesMax !== undefined) {
          this.caseSearchReq.overdueDatesMin = temp.overdueDatesMin ? temp.overdueDatesMin : null;
          this.caseSearchReq.overdueDatesMax = temp.overdueDatesMax ? temp.overdueDatesMax : null;
        } else if (temp.overdueDates && Array.isArray(temp.overdueDates)) {
          this.caseSearchReq.overdueDatesMin = temp.overdueDates[0];
          this.caseSearchReq.overdueDatesMax = temp.overdueDates[1];
        } else {
          this.caseSearchReq.overdueDatesMin = null;
          this.caseSearchReq.overdueDatesMax = null;
        }
        this.caseSearchReq.urgeStatus = temp.urgeStatus ? temp.urgeStatus : [];
        this.caseSearchReq.keyStr = temp.keyStr ? temp.keyStr : null;
        this.caseSearchReq.label = temp.label ? temp.label : '进件号';
        this.caseSearchReq.callSuccessCountMin = temp.callSuccessCountMin ? temp.callSuccessCountMin : null;
        this.caseSearchReq.callSuccessCountMax = temp.callSuccessCountMax ? temp.callSuccessCountMax : null;
        this.caseSearchReq.msgSuccessCountMin = temp.msgSuccessCountMin ? temp.msgSuccessCountMin : null;
        this.caseSearchReq.msgSuccessCountMax = temp.msgSuccessCountMax ? temp.msgSuccessCountMax : null;
        this.caseSearchReq.callProcessCountMin = temp.callProcessCountMin ? temp.callProcessCountMin : null;
        this.caseSearchReq.callProcessCountMax = temp.callProcessCountMax ? temp.callProcessCountMax : null;
        this.caseSearchReq.latestAnswerDurationMin = temp.latestAnswerDurationMin ? temp.latestAnswerDurationMin : null;
        this.caseSearchReq.latestAnswerDurationMax = temp.latestAnswerDurationMax ? temp.latestAnswerDurationMax : null;
        // 默认
        this.batchNoDefault = temp.batchNo ? temp.batchNo : [];
        this.caseStatusDefault = temp.caseStatus ? temp.caseStatus : [];
        this.selfStatusDefault = temp.selfStatus ? temp.selfStatus : [];
        this.contactStatusDefault = temp.contactStatus ? temp.contactStatus : [];
      }
    },
    numberCallSuccessCountMin() {
      this.caseSearchReq.callSuccessCountMin = this.caseSearchReq.callSuccessCountMin.replace(/[^\\.\d]/g, '');
      this.caseSearchReq.callSuccessCountMin = this.caseSearchReq.callSuccessCountMin.replace('.', '');
    },
    numberCallSuccessCountMax() {
      this.caseSearchReq.callSuccessCountMax = this.caseSearchReq.callSuccessCountMax.replace(/[^\\.\d]/g, '');
      this.caseSearchReq.callSuccessCountMax = this.caseSearchReq.callSuccessCountMax.replace('.', '');
    },
    numberMsgSuccessCountMin() {
      this.caseSearchReq.msgSuccessCountMin = this.caseSearchReq.msgSuccessCountMin.replace(/[^\\.\d]/g, '');
      this.caseSearchReq.msgSuccessCountMin = this.caseSearchReq.msgSuccessCountMin.replace('.', '');
    },
    numberMsgSuccessCountMax() {
      this.caseSearchReq.msgSuccessCountMax = this.caseSearchReq.msgSuccessCountMax.replace(/[^\\.\d]/g, '');
      this.caseSearchReq.msgSuccessCountMax = this.caseSearchReq.msgSuccessCountMax.replace('.', '');
    },
    numberCallProcessCountMin() {
      this.caseSearchReq.callProcessCountMin = this.caseSearchReq.callProcessCountMin.replace(/[^\\.\d]/g, '');
      this.caseSearchReq.callProcessCountMin = this.caseSearchReq.callProcessCountMin.replace('.', '');
    },
    numberCallProcessCountMax() {
      this.caseSearchReq.callProcessCountMax = this.caseSearchReq.callProcessCountMax.replace(/[^\\.\d]/g, '');
      this.caseSearchReq.callProcessCountMax = this.caseSearchReq.callProcessCountMax.replace('.', '');
    },
    numberLatestAnswerDurationMin() {
      this.caseSearchReq.latestAnswerDurationMin = this.caseSearchReq.latestAnswerDurationMin.replace(/[^\\.\d]/g, '');
      this.caseSearchReq.latestAnswerDurationMin = this.caseSearchReq.latestAnswerDurationMin.replace('.', '');
    },
    numberLatestAnswerDurationMax() {
      this.caseSearchReq.latestAnswerDurationMax = this.caseSearchReq.latestAnswerDurationMax.replace(/[^\\.\d]/g, '');
      this.caseSearchReq.latestAnswerDurationMax = this.caseSearchReq.latestAnswerDurationMax.replace('.', '');
    },
    numberOverdueDatesMin() {
      this.caseSearchReq.overdueDatesMin = this.caseSearchReq.overdueDatesMin.replace(/[^\d-]/g, '');
      this.caseSearchReq.overdueDatesMin = this.caseSearchReq.overdueDatesMin.replace(/(?!^)-/g, '');
    },
    numberOverdueDatesMax() {
      this.caseSearchReq.overdueDatesMax = this.caseSearchReq.overdueDatesMax.replace(/[^\d-]/g, '');
      this.caseSearchReq.overdueDatesMax = this.caseSearchReq.overdueDatesMax.replace(/(?!^)-/g, '');
    }
  },
  components: {
    BatchSelector, CaseStatusSelector, SelfStatusSelector, ContactStatusSelector, listOperate
  }
};
</script>
<style lang="less" scoped>
.rate-component {
  span {
    display: inline-block;
    width: 20px;
    vertical-align: middle;
  }
  & > div {
    display: inline-block;
    width: 160px;
    vertical-align: middle;
  }
}
.overdue-dates-form-item ::v-deep .el-form-item__content {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.overdue-input {
  width: 120px;
  margin-left: 8px;
}
.overdue-separator {
  margin: 0 6px;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/page/main/case/caseList.vue